import { Tooltip as Tooltip$1 } from '@primer/react/deprecated';
import { forwardRef } from 'react';
import sx from '../../sx.js';
import styled from 'styled-components';
import { jsx } from 'react/jsx-runtime';

const StyledTooltip = styled(Tooltip$1).withConfig({
  shouldForwardProp: prop => prop !== 'sx'
}).withConfig({
  displayName: "Tooltip__StyledTooltip",
  componentId: "sc-145jcib-0"
})(["", ""], sx);
const TooltipImpl = /*#__PURE__*/forwardRef(function Tooltip({
  as,
  ...props
}, ref) {
  return /*#__PURE__*/jsx(StyledTooltip, {
    ...props,
    ...(as ? {
      forwardedAs: as
    } : {}),
    ref: ref
  });
});
const Tooltip = TooltipImpl;

// Preserve static properties from the original component
Tooltip.alignments = Tooltip$1.alignments;
Tooltip.directions = Tooltip$1.directions;
Tooltip.__SLOT__ = Tooltip$1.__SLOT__;

export { Tooltip };
